'use strict';
moduleConfig.registerModule('eclipseApp.support', ['eclipseApp.core']);
